import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import FlatButton from 'material-ui/FlatButton';
import InputSlider from '../components/InputSlider';

import QbankButton from '../components/QbankButton';
import { ASSET_PREFIX } from '../config/constants';
import { updateSettings, resetQuestions, changeState } from '../actions/index';

import '../styles/Settings.css';

// const difficultyScale = 10;
const styles = {
  button: { width: '200px', height: '45px' }
};

class Settings extends Component {
  constructor(props) {
    super(props);
    const { settings, params } = this.props;
    const retireVal =
      settings && (settings.retireAfterCount || settings.retireAfterCount === 0)
        ? settings.retireAfterCount
        : 2;

    this.state = {
      confirmDialogOpen: false,
      retireVal,
      intro: params.firstRun
    };

    this.changeSliderSetting = _.debounce(this.changeSliderSetting, 300);
  }

  render() {
    // const actions = [
    //   <FlatButton
    //     label="Cancel"
    //     className="submit-button"
    //     primary={true}
    //     onTouchTap={(e, val) => this.cancelResetQuestions()}
    //   />,
    //   <FlatButton
    //     label="Reset"
    //     className="submit-button"
    //     primary={true}
    //     onTouchTap={(e, val) => this.resetQuestions()}
    //   />,
    // ];
    const retireText = [
      'Once you answer a question correctly it will be removed from your rotation.',
      "If you answer a question correctly, you'll see it one more time to make sure you've got it retained.",
      "You'll see correctly answered questions twice - once to make sure you weren't just lucky, and a second time to make sure you've got it down pat."
    ];
    const intro = this.state.intro;
    const book = this.props.product
      ? require(`../images/${ASSET_PREFIX[this.props.product]}-book@3x.png`)
      : null;

    return (
      <div
        style={
          intro === 1
            ? { minHeight: 'calc(100vh - 100px)' }
            : intro === 2 ? { minHeight: '100vh' } : {}
        }
        className="settings-container"
      >
        {intro ? (
          <div className="settings-intro">
            <img src={book} alt="" />
            <p>How do you study?</p>
            <p>
              {intro === 1
                ? "Research shows repetition increases retention but if you're short on time, chose to retire questions after you've gotten them right and they'll be removed from the rotation. Want to keep practicing? Set to \"Never\"."
                : "We've got a lot of questions. Space your repetition depending on how much time you've got to study.\nLots of time? Longer space. Cramming? Keep it short."}
            </p>
          </div>
        ) : (
          <div className="title-wrap">
            <div className="qbank-title">QBANK SETTINGS</div>
            <div className="settings-sub-header">
              Customizable Spaced Repetition
              <div className="settings-explanation">
                Save time and maximize retention by controlling how often you
                see questions.
              </div>
            </div>
          </div>
        )}
        <div className="settings-content-wrapper">
          <div className="settings-sub-wrapper">
            {!intro || intro === 1 ? (
              <div>
                <div className="setting-row">
                  <div className="settings-explanation">
                    {retireText[this.state.retireVal]}
                  </div>
                  <div className="setting-label">
                    Retire questions after I have correctly answered them
                    consecutively:
                  </div>
                  <div className="setting-value">
                    <FlatButton
                      className={
                        this.state.retireVal === 1
                          ? 'push-button-active'
                          : 'push-button'
                      }
                      label="One Time"
                      onClick={(e, val) =>
                        this.changeSetting('retireAfterCount', 1)
                      }
                    />
                    <FlatButton
                      className={
                        this.state.retireVal === 2
                          ? 'push-button-active'
                          : 'push-button'
                      }
                      label="Two Times"
                      onClick={(e, val) =>
                        this.changeSetting('retireAfterCount', 2)
                      }
                    />
                    <FlatButton
                      className={
                        this.state.retireVal === 0
                          ? 'push-button-active'
                          : 'push-button'
                      }
                      label="Never"
                      onClick={(e, val) =>
                        this.changeSetting('retireAfterCount', 0)
                      }
                    />
                  </div>
                </div>
                <div className="setting-row-separator" />
              </div>
            ) : null}
            {!intro || intro === 2 ? (
              <div>
                <div className="setting-row">
                  <div className="settings-explanation">
                    You've chosen to see correctly answered questions again for
                    deeper retention. How soon would you like to see those
                    questions again in the rotation?<br />TIP: If you’re short
                    on time, set the number higher.
                  </div>
                  <div className="setting-label">
                    Show me correctly answered questions after:
                  </div>
                  <div className="setting-value">
                    <InputSlider
                      min={0}
                      max={31}
                      step={1}
                      unit="days"
                      defaultValue={
                        this.getSetting('showCorrectAfter') === null
                          ? 7
                          : this.getSetting('showCorrectAfter')
                      }
                      onChange={val =>
                        this.changeSliderSetting('showCorrectAfter', val)
                      }
                    />
                  </div>
                </div>
                {!intro || intro === 2 ? (
                  <div>
                    <div className="setting-row-separator" />
                    <div className="setting-row">
                      <div className="settings-explanation">
                        How soon would you like to see the questions you've
                        answered incorrectly? If you've got a while to study, we
                        recommend 2 days.<br />
                        TIP: If you’re short on time, set the number higher.
                      </div>
                      <div className="setting-label">
                        Show me incorrectly answered questions after:
                      </div>
                      <div className="setting-value">
                        <InputSlider
                          min={0}
                          max={31}
                          step={1}
                          unit="days"
                          defaultValue={
                            this.getSetting('showIncorrectAfter') === null
                              ? 2
                              : this.getSetting('showIncorrectAfter')
                          }
                          onChange={val =>
                            this.changeSliderSetting('showIncorrectAfter', val)
                          }
                        />
                      </div>
                    </div>
                  </div>
                ) : null}
                {/*<div className='setting-row-separator' />*/}
                {/*<div className='setting-row'>*/}
                {/*<div className="settings-explanation">*/}
                {/*Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras ornare lorem eu felis tincidunt, ut*/}
                {/*tincidunt urna ultricies. Curabitur porta at lectus non venenatis.*/}
                {/*</div>*/}
                {/*<div className='setting-label'>*/}
                {/*Difficulty:*/}
                {/*</div>*/}
                {/*<div className='setting-value'>*/}
                {/*<InputSlider*/}
                {/*min={-1 * difficultyScale}*/}
                {/*max={difficultyScale}*/}
                {/*step={1}*/}
                {/*unit=""*/}
                {/*defaultValue={this.getSetting('qbankDifficulty') === null ? 0 : this.getSetting('qbankDifficulty') * difficultyScale}*/}
                {/*onChange={(val) => this.changeSliderSetting('qbankDifficulty', val / difficultyScale)}*/}
                {/*/>*/}
                {/*</div>*/}
                {/*</div>*/}
              </div>
            ) : null}
            {/*<div className='setting-row-separator' />*/}
            {/*<div className='setting-row'>*/}
            {/*<div className='setting-label'>*/}
            {/*Reset all questions:*/}
            {/*</div>*/}
            {/*<div className='setting-value'>*/}
            {/*<FlatButton*/}
            {/*className="submit-button"*/}
            {/*label="Reset All"*/}
            {/*onClick={(e, val) => this.promptResetQuestions()}*/}
            {/*/>*/}
            {/*<Dialog*/}
            {/*title="Reset All Questions"*/}
            {/*actions={actions}*/}
            {/*modal={true}*/}
            {/*open={this.state.confirmDialogOpen}*/}
            {/*className="settings-dialog"*/}
            {/*>*/}
            {/*Are you sure you want to reset all your questions?*/}
            {/*</Dialog>*/}
            {/*</div>*/}
            {/*</div>*/}
          </div>
        </div>
        <QbankButton
          label="SAVE AND CONTINUE"
          style={styles.button}
          onClick={() =>
            intro === 1
              ? this.setState({ intro: 2 })
              : this.props.changeState('init', { intro })
          }
        />
      </div>
    );
  }

  promptResetQuestions() {
    this.setState({ confirmDialogOpen: true });
  }

  resetQuestions() {
    this.setState({ confirmDialogOpen: false });
    this.props.resetQuestions();
  }

  cancelResetQuestions() {
    this.setState({ confirmDialogOpen: false });
  }

  changeSetting(key, val) {
    this.props
      .updateSettings(key, val)
      .then(() => this.setState({ retireVal: val }));
  }

  changeSliderSetting(key, val) {
    this.props.updateSettings(key, val);
  }

  getSetting(key) {
    if (this.props.settings && this.props.settings[key] !== undefined) {
      return this.props.settings[key];
    }
    return null;
  }
}

function mapStateToProps(state) {
  const settings =
    state.app && state.app.settings ? state.app.settings.values : null;
  return {
    settings,
    product: state.app.product
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { updateSettings, resetQuestions, changeState },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings);



// WEBPACK FOOTER //
// ./src/containers/Settings.js